import $ from 'jquery';

// Front Page - Pin Toggle
$('.js--pin-toggle').on('click', function() {
	$(this).find('.info__pin__wrap__toggle').toggleClass('open');
	$('.js--info-content').toggleClass('info__content--is-open');
})

// Front Page - Hero Video
function heroOnLoad() {
    var video = $('video'),
        hero = $('.hero-video');
    if ($(window).width() >= 800) {
        $("#video").bind("loadedmetadata", function () {
            var videoHeight = video.height();
            hero.css('height', videoHeight);
        });
    }
}
function heroOnResize() {
    var video = $('video'),
        hero = $('.hero-video');
    if ($(window).width() >= 800) {
        var videoHeight = video.height();
        hero.css('height', videoHeight);
    }
}
heroOnLoad();
$(window).on('resize', function() {
    heroOnResize();
}).trigger('resize');
